import { AxiosRequestConfig } from 'axios';
import axios from '../ApiHelpers';

export const getPins = (data:any, config: AxiosRequestConfig) => {
    try {
      return axios.post('/services/app/Location/GetPins', data, config);
    } catch (e) {
        console.log('Get pin failed', e);
    }
  };